module.exports = __webpack_public_path__ + "static/media/paredocientec.375b21e9.mp4";